export default __webpack_public_path__ + "static/media/H4004.41219dfb.mp3";